import { useState } from 'react'
import './admin.css'
import { submitSongsData } from './dataStore/submitSongsData'
import Input from './Input'



const INPUT_DATA=[
    {placeHolder:'Songs ID',name:'sId',type:'text'},{placeHolder:'Songs name',name:'sName',type:'text'},
    {placeHolder:'Songs',name:'song',type:'text'}, {placeHolder:'Songs image',name:'sLink',type:'text'},
    {placeHolder:'Movie/Album name',name:'maName',type:'text'},{placeHolder:'Songs duration',name:'sDuration',type:'time'}
]

export default function Admin(){
    const [crrValue,setValue]=useState({sType:'',sName:'',sLink:'',maName:'',sDuration:''})
    function handleChange(e){  setValue({...crrValue,[e.target.name]:e.target.value})  }

    
    return(
        <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4 admsz">
                <center>
                    <h3>𝄞 SANGEET</h3>
                    <h5 className="mt-5">Admin Page</h5>
                    <select name="sType" className="mt-3" onChange={handleChange}>
                        <option value="">Select songs type</option>
                        <option value="new_song">New Songs</option>
                        <option value="old_song">Old Songs</option>
                    </select><br/>
                    {
                        INPUT_DATA.map((val,index)=>{
                            return(
                                <Input 
                                    type={val.type}
                                    placeholder={val.placeHolder} 
                                    name={val.name} 
                                    className="mt-3"
                                    onChange={handleChange}
                                    key={index}     
                                />
                            )
                        })
                    }
                    <button type="submit" onClick={()=>submitSongsData(crrValue)} className="btn btn-primary btn-md mt-4">Submit</button>
                </center>
            </div>
            <div className="col-md-4"></div>
        </div>
    )
}